import { TaxType } from './types.ts'

interface TaxProps {
  tax: TaxType
}

export default function Tax({ tax }: TaxProps) {
  return (
    <div>
      <p className="my-5">
        <strong className="block font-medium mb-1">Nom :</strong>
        {tax.name?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Code:</strong>
        {tax.code?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Communauté :</strong>
        {tax.community_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Actif :</strong>
        {tax.active?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Catégorie:</strong>
        {tax.category_id?.toString()}
      </p>
      <p className="my-5">
        <strong className="block font-medium mb-1">Type de taxe :</strong>
        {tax.tax_type_id?.toString()}
      </p>
    </div>
  )
}
